import { BaseApiRouteService } from "mrb/core";

class NakiNigunImportApiRouteService extends BaseApiRouteService {
    constructor() {
        super("naki-nigun-import");
    }

    find(filter) {
        return super.find(`${this.base}/batches{?searchQuery,page,rpp,sort}`, filter);
    }

    get(id, options) {
        return super.get(`${this.base}/batches/{id}`, id, options);
    }

    enable(id) {
        return super.update(`${this.base}/batches/{id}/enable`, { id });
    }

    saveMetadata(id) {
        return super.update(`${this.base}/batches/{id}/metadata`, { id });
    }

    addToSystem(id) {
        return super.create(`${this.base}/batches/{id}/add-to-system`, { id });
    }

    uploadArtwork() {
        return super.create(`${this.base}/artwork`);
    }

    refresh() {
        return super.create(`${this.base}/trigger`);
    }

    discard(id) {
        return super.delete(`${this.base}/batches/{id}`, { id });
    }
}

export default NakiNigunImportApiRouteService;
